import { ClientHandler } from '../types';
import { disneyHandler } from './client-handlers/DISNEY/disney-handler';
import { resumidoHandler } from './client-handlers/RESUMIDO/resumido-handler';
import { GVAZHandler } from './client-handlers/GVAZ';
import { macroHandler } from './client-handlers/MACRO';
import { hipotecarioHandler } from './client-handlers/HIPOTECARIO/hipotecario-handler';
import { getHandlerKeyForTemplate } from '../clients/registry';
import { CreativityType } from '../types/banner';

const CLIENT_HANDLERS: Record<string, ClientHandler> = {
  DISNEY: disneyHandler,
  RESUMIDO: resumidoHandler,
  GVAZ: GVAZHandler,
  MACRO: macroHandler,
  HIPOTECARIO: hipotecarioHandler,
  TEST: macroHandler // No longer used, kept for backward compatibility
};

// Stable identity for clients without a handler: a fresh {} each call would re-render
// consumers forever (unstable computeDefaults → active-resolution loader re-runs → load loop).
const EMPTY_HANDLER: ClientHandler = {};

/**
 * Returns the appropriate handler based on the templateId.
 * Uses originalClientId when available (for TEST templates),
 * otherwise falls back to clientId.
 *
 * @param templateId - The template or banner type ID
 * @returns The corresponding ClientHandler, or an empty object if none is found
 */
export const getHandlerForTemplate = (templateId: CreativityType): ClientHandler => {
  const handlerKey = getHandlerKeyForTemplate(templateId);

  // If no template is found (legacy/migrated banners), return an empty handler
  if (!handlerKey) {
    return EMPTY_HANDLER;
  }

  return CLIENT_HANDLERS[handlerKey] || EMPTY_HANDLER;
};
